/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { Fragment, PureComponent } from 'react'
import { Theme } from '@themes/theme'

const Color = (theme: Theme) => css`
  width: inherit;
  height: auto;
  #arrow {
    fill: ${theme.color.themeTxt};
  }
  #bg {
    fill: ${theme.color.btn};
  }
`
export default class CircleDownIco extends PureComponent {
  render() {
    return (
      <Fragment>
        <svg xmlns="http://www.w3.org/2000/svg" width="35.999" height="36" viewBox="0 0 35.999 36" css={Color}>
          <g id="그룹_4183" data-name="그룹 4183" transform="translate(12117 23673)">
            <path id="bg" data-name="패스 3266" d="M2.418,27.024a18,18,0,1,1,15.609,9.005A18,18,0,0,1,2.418,27.024Z" transform="translate(-12117.01 -23673.029)" fill="#202f40" />
            <path id="arrow" data-name="Shape 814" d="M17.669,8.259a1.377,1.377,0,0,0-.447-1.01L9.9.414a1.583,1.583,0,0,0-2.134,0L.447,7.249A1.365,1.365,0,0,0,.44,9.263a1.583,1.583,0,0,0,2.142.007L8.835,3.431,15.088,9.27a1.584,1.584,0,0,0,2.142-.007A1.377,1.377,0,0,0,17.669,8.259Z" transform="translate(-12089.868 -23649.42) rotate(180)" fill="#acacac" />
          </g>
        </svg>
      </Fragment>
    )
  }
}
